import React from 'react';
import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight, Today } from '@mui/icons-material';
import { format, addWeeks } from 'date-fns';
import { vi } from 'date-fns/locale';

/**
 * WeekNavigator - navigation controls for weekly calendar
 * @param {Date} currentDate - current selected date
 * @param {function} onDateChange - callback when date changes
 * @param {Date} weekStart - start of current week
 * @param {Date} weekEnd - end of current week
 */
const WeekNavigator = ({ currentDate, onDateChange, weekStart, weekEnd }) => {
  const handlePreviousWeek = () => {
    onDateChange(addWeeks(currentDate, -1));
  };

  const handleNextWeek = () => {
    onDateChange(addWeeks(currentDate, 1));
  };

  const handleToday = () => {
    onDateChange(new Date());
  };

  return (
    <Paper sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton onClick={handlePreviousWeek} aria-label="Tuần trước">
          <ChevronLeft />
        </IconButton>

        <Typography variant="h6" sx={{ minWidth: 280, textAlign: 'center' }}>
          {format(weekStart, 'dd/MM/yyyy', { locale: vi })} - {format(weekEnd, 'dd/MM/yyyy', { locale: vi })}
        </Typography>

        <IconButton onClick={handleNextWeek} aria-label="Tuần sau">
          <ChevronRight />
        </IconButton>
      </Box>

      <Button
        variant="outlined"
        startIcon={<Today />}
        onClick={handleToday}
        size="small"
      >
        Hôm nay
      </Button>
    </Paper>
  );
};

export default WeekNavigator;
